<template>
    <div class="yy-empty">
        <img :src="typeList[type].src">
        <p>{{text||typeList[type].text}}</p>
    </div>
</template>
<script>
    import { t } from '../../../locale/'

    const path = 'https://imoss.yonyoucloud.com/suite/cooperation/images/tips/'
    export default {
        name: "YYEmpty",
        props: {
            type: {
                type: String,
                default: "nodata"
            },
            text: {
                type: String
            }
        },
        data() {
            return {
                typeList: {
                    nodata: {
                        src: `${path}tip_nodata.png`,
                        text: t('empty.noData')
                    },
                    404: {
                        src: `${path}tip_404.png`,
                        text: "404"
                    },
                    maintain: {
                        src: `${path}tip_maintain.png`,
                        text: t('empty.underConstructionAndWorkingHardToMaintain')
                    },
                    noattention: {
                        src: `${path}tip_follow.png`,
                        text: t('empty.noAttention')
                    },
                    nonetwork: {
                        src: `${path}tip_internet.png`,
                        text: t('empty.noNetwork')
                    },
                    noserver: {
                        src: `${path}tip_server.png`,
                        text: t('empty.theServerIsWrong')
                    },
                    wait: {
                        src: `${path}tip_approval.png`,
                        text: t('empty.pleaseWaitPatientlyForCertificationAndReview')
                    },
                    nosearch: {
                        src: `${path}tip_search.png`,
                        text: t('empty.searchNoResults')
                    }
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/base/empty/empty.vue